import React from 'react'

import { BottomSheet } from '@interco/inter-toranja'
import {
  BOTTOM_SHEET_EXPANSIBLE,
  BOTTOM_SHEET_OVERLAY,
} from '@interco/inter-toranja/dist/components/Molecules/BottomSheet/types'
import useGlobalState from '@/contexts/global-state'
import type { TagProps } from '@interco/inter-toranja/dist/types/shared'
import { requestAnalyticsFromToranjaTag } from '@/utils/analytics/requestAnalyticsFromToranjaTag'
import * as Actions from '@/contexts/global-state/reducer/actions'
import type { ComponentType } from '@/components/DynamicComponent/interfaces'

import DynamicComponent from '..'

import * as S from './styles'

export const GlobalBottomSheet = () => {
  const [{ globalBottomSheet, homeCreditOnboarding }, dispatch] = useGlobalState()
  const screenName = homeCreditOnboarding?.screen?.metadata?.analytics?.screen_name ?? ''

  const handleClose = () => {
    dispatch(Actions.closeGlobalBottomSheet({}))
  }

  const handleTag = (tag: TagProps) => {
    requestAnalyticsFromToranjaTag(tag, screenName, globalBottomSheet.title ?? '')
  }

  if (!globalBottomSheet.isOpen) {
    return null
  }

  return (
    <S.ContainerBottomSheet>
      <BottomSheet
        title={globalBottomSheet.title}
        isOpen
        close={handleClose}
        overlay={BOTTOM_SHEET_OVERLAY.ON}
        expansible={BOTTOM_SHEET_EXPANSIBLE.OFF}
        position={
          (globalBottomSheet.position as 'hug' | 'expanded' | 'middle' | 'collapsed') ?? 'hug'
        }
        onTag={handleTag}
        slot={
          <S.ContainerBottomSheetInner>
            {globalBottomSheet.components.map((component) => (
              <DynamicComponent
                key={component.id}
                type={component.type as ComponentType}
                sduiComponent={{
                  id: component.id,
                  type: component.type,
                  style: component.style,
                  props: component.props,
                  path: component.path,
                }}
              />
            ))}
          </S.ContainerBottomSheetInner>
        }
      />
    </S.ContainerBottomSheet>
  )
}
